module.exports = __webpack_public_path__ + "static/media/call-calling.9121b319.svg";